import type { TaskResult } from "../types";

function normalizeFormula(value: string | undefined): string {
  return (value ?? "")
    .replace(/\$/g, "")
    .replace(/\s+/g, "")
    .replace(/^=/, "")
    .toUpperCase();
}

export async function gradeProject16(): Promise<TaskResult[]> {
  const results: TaskResult[] = [];

  // Tarea 1: Verificar referencia mixta B$15 en F4 y que se copió hasta F11
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Bonos de empleados");
      const startCell = sheet.getRange("F4");
      const endCell = sheet.getRange("F11");
      startCell.load("formulas,values");
      endCell.load("formulas,values");
      await context.sync();

      // Check RAW formula for mixed reference (B$15, not B15 or $B$15)
      const rawStart = String(startCell.formulas[0][0] ?? "").toUpperCase();
      const rawEnd = String(endCell.formulas[0][0] ?? "").toUpperCase();
      const hasMixedRef = rawStart.includes("B$15") && !rawStart.includes("$B$15");
      const startHasE4 = rawStart.includes("E4");
      const endHasE11 = rawEnd.includes("E11");
      const valueCorrect = Math.abs(Number(startCell.values[0][0]) - 12268.4) < 0.01;

      results.push({
        taskId: 1,
        passed: hasMixedRef && startHasE4 && endHasE11 && valueCorrect,
      });
    });
  } catch {
    results.push({ taskId: 1, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Bonos de empleados");
      const startCell = sheet.getRange("G4");
      const endCell = sheet.getRange("G11");
      startCell.load("formulas,values");
      endCell.load("formulas,values");
      await context.sync();

      const startFormula = normalizeFormula(String(startCell.formulas[0][0] ?? ""));
      const endFormula = normalizeFormula(String(endCell.formulas[0][0] ?? ""));
      // Accept =SUM(F4:F4) or =SUMA(F4:F4) or =F4 (all valid)
      const startValid =
        (startFormula.includes("SUM") && startFormula.includes("F4")) ||
        startFormula === "F4";
      const endValid =
        (endFormula.includes("SUM") && endFormula.includes("F11")) ||
        endFormula === "F11";
      const passed =
        startValid && endValid &&
        Number(startCell.values[0][0]) > 12268 &&
        Number(endCell.values[0][0]) > 7600;
      results.push({ taskId: 2, passed });
    });
  } catch {
    results.push({ taskId: 2, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Partes");
      const names = sheet.getRange("A4:A20");
      names.load("values");
      await context.sync();

      const flattened = names.values.flat().map((value) => String(value ?? "").trim());
      results.push({
        taskId: 3,
        passed: !flattened.includes("Allen"),
      });
    });
  } catch {
    results.push({ taskId: 3, passed: false });
  }

  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Partes");
      const table = sheet.tables.getItemAt(0);
      table.load("style");
      await context.sync();

      // Only check "Medium1" — color prefix varies across Excel versions
      results.push({
        taskId: 4,
        passed: String(table.style).toUpperCase().includes("MEDIUM1"),
      });
    });
  } catch {
    results.push({ taskId: 4, passed: false });
  }

  // Tarea 5: Minigráfico de línea en F4.
  // Office.js no expone sparklines, pero al insertar uno se reemplaza
  // el placeholder "(Minigráfico)" que pusimos en el setup.
  try {
    await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getItem("Partes");
      const cellF4 = sheet.getRange("F4");
      cellF4.load("values");
      await context.sync();

      const val = String(cellF4.values[0][0] ?? "").trim();
      // Passed if the placeholder text was replaced (sparkline clears cell content)
      results.push({ taskId: 5, passed: val !== "(Minigráfico)" && val === "" });
    });
  } catch {
    results.push({ taskId: 5, passed: false });
  }

  return results;
}
